<template>
    <template v-if="!s.request">
        <div class="bg-white rounded p-4 mb-4">
            <div class="flex justify-between items-center gap-4">
                <div class="flex justify-center items-center text-slate-500 gap-2">
                    ОБЪЯВЛЕНИЯ <span class="count">{{ ads?.length }}</span>
                </div>
            </div>
        </div>

        <template v-if="projects">
            <template v-for="project in projects" :key="project">
                <template v-if="project.id && project.id > 0">
                    <div class="bg-white rounded mt-8">
                        <div class="flex justify-between items-center h-12 px-4 gap-4 text-lg text-sky-800 border-b border-slate-200">
                            <div>
                                <span class="text-xs">{{ project.id }}</span> {{ project.name }}
                            </div>
                            <div @click="closeItem(project.id)" :class="{ 'rotate-180': closeIds.has(project.id) }"><IconAltDown :size="6" /></div>
                        </div>
                        <template v-if="!closeIds.has(project.id)">
                            <template v-for="client in project.clients" :key="client">
                                <div class="flex justify-between items-center h-12 px-4 gap-4 text-md text-slate-500 border-b border-slate-200">
                                    <div>
                                        <span class="text-xs">{{ client.id }}</span>
                                        {{ client.name }}
                                        <span class="count ml-10"> {{ client.items?.length }}</span>
                                    </div>
                                    <div @click="closeItem(client.id)" :class="{ 'rotate-180': closeIds.has(client.id) }">
                                        <IconAltDown :size="6" />
                                    </div>
                                </div>
                                <template v-if="!closeIds.has(client.id)">
                                    <template v-for="item in client.items" :key="item.id">
                                        <div
                                            class="h-12 overflow-hidden grid grid-cols-12 items-center gap-4 px-4 border-b border-slate-200 text-xs hover:bg-sky-50/50 hover:!text-sky-700"
                                        >
                                            <div>
                                                <a
                                                    v-if="item.url"
                                                    class="w-full rounded-r-full rounded-tl-full bg-sky-600 py-1 px-3 text-center text-md text-white cursor-pointer"
                                                    :class="{ '!bg-amber-400': item.erid == 'none' }"
                                                    target="_blank"
                                                    :href="item.url"
                                                >
                                                    {{ item.erid }}
                                                </a>
                                            </div>

                                            <div class="flex items-center gap-4 col-span-6">
                                                <a
                                                    v-if="item.channel_id == 1"
                                                    class="text-2xl text-sky-600 font-bold text-right cursor-pointer"
                                                    target="_blank"
                                                    :href="'https://vk.com/ads?act=office&union_id=' + item.id"
                                                >
                                                    <IVk />
                                                </a>
                                                <a
                                                    v-if="item.channel_id == 2"
                                                    class="text-2xl text-sky-600 font-bold text-right cursor-pointer p-1"
                                                    target="_blank"
                                                    href="https://ads.vk.com/hq/dashboard"
                                                >
                                                    <IVkAds :size="6" />
                                                </a>
                                                <div>
                                                    <span class="text-xs text-slate-400">{{ item.id }}</span>
                                                    <div class="text-[13px]">{{ item.name }}</div>
                                                </div>
                                            </div>

                                            <div>
                                                <div class="text-teal-500" v-if="item.approved == 2"><IconOk /></div>
                                                <div class="text-red-500" v-if="item.approved == 1"><IconMinus /></div>
                                            </div>

                                            <div class="text-xs leading-4 col-span-2">{{ ad_formats[item.ad_format] }}</div>

                                            <div class="text-xs">
                                                <div v-if="item.created">{{ moment.unix(item.created).format("DD.MM.YYYY") }}</div>
                                            </div>

                                            <div>
                                                <div class="flex justify-end items-center gap-2 mr-1" v-if="item.status == 1">
                                                    <span class="circle bg-teal-500"></span>
                                                </div>
                                                <div class="flex justify-end items-center gap-2 mr-1" v-if="item.status == 0">
                                                    <span class="circle bg-pink-500"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </div>
                </template>
            </template>
        </template>
    </template>

    <div v-else class="flex justify-center items-center h-screen text-sky-400"><IconLoader :size="30" /></div>

    <template v-if="s.popup == 'addClient'"><AddClient /></template>
    <div v-if="s.popup" @click="closePopup()" class="fixed bg-slate-900 z-10 w-screen h-screen top-0 left-0 opacity-80"></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "MyAds",

    data() {
        return {
            moment: moment,
            closeIds: new Set(),

            ad_formats: {
                1: "изображение и текст",
                2: "большое изображение",
                3: "эксклюзивный формат",
                4: "продвижение сообществ",
                5: "приложение в новостной ленте",
                6: "мобильное приложение",
                9: "запись в сообществе",
                11: "адаптивный формат",
                12: "истории",
            },
        };
    },

    computed: {
        ...mapGetters(["s", "select", "profile", "ads"]),

        projects() {
            if (!this.ads || this.ads.length < 1) return null;

            var startTime = performance.now();

            const grouped = this.ads.reduce((result, item) => {
                const outerKey = item.project_id;
                const innerKey = item.client_id;

                if (!result[outerKey]) {
                    result[outerKey] = { id: item.project_id, name: item.project, clients: {} };
                }

                if (!result[outerKey].clients[innerKey]) {
                    result[outerKey].clients[innerKey] = {
                        id: item.client_id,
                        name: item.client,
                        counter_type: item.counter_type,
                        counter_id: item.counter_id,
                        goal_id: item.goal_id,
                        items: [],
                    };
                }

                result[outerKey].clients[innerKey].items.push(item);
                return result;
            }, {});

            var endTime = performance.now();
            console.log("time new", endTime - startTime + "ms");

            return grouped;
        },
    },

    methods: {
        ...mapActions(["getTargetologAds", "setPopup", "closePopup", "clearSettings"]),

        closeItem(id) {
            if (this.closeIds.has(id)) {
                this.closeIds.delete(id);
            } else {
                this.closeIds.add(id);
            }
        },
    },

    mounted() {
        this.getTargetologAds();
    },
};
</script>
